import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga4'
import { initMetaPixel } from './analytics';

const TRACKING_ID = "G-Y57LZLFD2R";
ReactGA.initialize(TRACKING_ID);
initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <div style={{position: 'absolute', background: '#FFC100', width: '100%', height: '100%', padding: '22px 18px'}}>
      <div style={{background: '#008248', width: '100%', height: '100%', padding: '10px'}}>
          <span className="frame-corner tl" />
          <span className="frame-corner tr" />
          <span className="frame-corner bl" />
          <span className="frame-corner br" />
          <div style={{backgroundImage: 'url(assets/images/star-bg.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: '#55ADC9', width: '100%', height: '100%'}}>
          </div>
      </div>
    </div> */}
      <App />
  </React.StrictMode>
);
reportWebVitals();
